import {Injectable} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders, HttpContextToken} from '@angular/common/http';
import {Observable, from, throwError, of} from 'rxjs';
import {switchMap, filter, take, timeout, catchError} from 'rxjs/operators';
import {ApiService} from './api.service';
import {getStoredItem} from '../utils/storage';

export const SKIP_JWT_GATE = new HttpContextToken<'primitive' | 'legacy' | false>(() => false);

const noInterceptor = [
  'https://maps.googleapis.com/maps',
  'ping'
];

@Injectable()
export class JwtInterceptorService implements HttpInterceptor {

  constructor(private api: ApiService) {
  }
  
  private getHttpOptions(): object {

    const token = this.api.accountJwt?.jwt;
    
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json'
      })
    };

    if(token) {
      options.headers = options.headers.append('Authorization', 'Bearer ' + token);
    }
    return options;
  }
  
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.api.accountJwt?.jwt || getStoredItem('jwt');

    const nextRequest = () => {
      const authReq = request.clone(this.getHttpOptions());
      return next.handle(authReq);
    };
    const skip = request.context.get(SKIP_JWT_GATE);
    if(skip === 'primitive') return next.handle(request);
    if(skip === 'legacy') return nextRequest();
    if(!token || noInterceptor.some(url => request.url.includes(url))) {
      return next.handle(request);
    } else if(this.api.isCheckingJwt){
      if(!this.api.activeTokenUnusable()) return nextRequest();
      return this.api.tokenState$.pipe(filter((s: string) => s === 'dead' || s === 'retryable' || !this.api.activeTokenUnusable()), take(1), timeout(10000), catchError(() => of('retryable' as const)), switchMap((s: string) => (s === 'dead' || s === 'retryable' || this.api.activeTokenUnusable()) ? throwError(() => ({status: 0})) : nextRequest()));
    } else {
      return from(this.api.checkJwt(true)).pipe(switchMap(() => nextRequest()));
    }
  }
}
